'use client';

import { motion } from 'motion/react';

import { TestimonialsWall } from '@workspace/billing/components/testimonials-wall';

export default function Testimonials() {
  return (
    <section className="py-14 sm:py-20 md:py-24 bg-section-green">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-14">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="inline-flex items-center rounded-full border border-primary/20 px-3 py-1 text-xs font-medium text-primary mb-4 bg-videomule-light-green dark:bg-primary/10">
              Testimonials
            </span>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground">
              See What the Hype Is About
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <p className="mt-3 text-sm sm:text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
              Real results achieved by real users with engaging AI-voiceover
              videos!
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <TestimonialsWall />
        </motion.div>

        <motion.div
          className="flex justify-center mt-8 sm:mt-10"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.3 }}
        >
          <img
            src="/assets/homepage/featured-on-taaft.webp"
            alt="Featured on There's an AI for That"
            className="h-10 sm:h-12 md:h-14 w-auto object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
}
